import React from "react"
import SelectDynamicElementsModal from "components/DynamicElements/SelectDynamicElementsModal"
import ModalExpireFreeTrial from "components/UserView/ModalExpireFreeTrial"
import ModalDebtor from "components/UserView/ModalDebtor"
import { useBudget2023Context } from "context/budget2023/Budget2023Context"
import { WRAPPER_MODALS } from "context/types"
import { useWrapperModals } from "context/wrapperModals/WrapperModalsContext"
import ModalImportPartFromBc3Link from "pages/ModalPartidas/ModalImportPartFromBc3Link"
import NewModalPartida from "pages/ModalPartidas/NewModalPartida"
import PartBrowserModal from "components/Budgeting2023/modals/PartBrowserModal"
import { ModalPartidaProvider } from "context/modalPartidas/ModalPartidaContext"

const WrapperModals = () => {
  const { dynamicElement } = useBudget2023Context()
  const { newModalPart, bc3Link, partBrowser } = useWrapperModals()

  return (
    <div aria-describedby="modals">
      <SelectDynamicElementsModal
        isOpen={dynamicElement.modalIsOpen}
        onClose={isOpen => {
          dynamicElement.setModalIsOpen(isOpen)
          dynamicElement.setProjectId(null)
        }}
        setSelectedElements={data => {
          dynamicElement.setSelected(data)
          dynamicElement.setModalIsOpen(false)
          dynamicElement.setProjectId(null)
        }}
        projectId={dynamicElement.projectId}
      />

      <ModalExpireFreeTrial />
      <ModalDebtor />

      <ModalPartidaProvider>
        {newModalPart.open === true && (
          <NewModalPartida
            from={newModalPart.from || WRAPPER_MODALS}
            open={newModalPart.open}
            setOpen={(isOpen, additionalData) =>
              newModalPart.setProperty({
                open: isOpen,
                from: additionalData?.from ?? WRAPPER_MODALS,
                chapterId: additionalData?.chapterId ?? null,
                partida: additionalData?.partida ?? null,
                bancoDePrecios: additionalData?.bancoDePrecios ?? "",
                srcPage: additionalData?.srcPage ?? "",
              })
            }
            srcPage={newModalPart.srcPage}
            chapterId={newModalPart.chapterId}
            partidaInfo={newModalPart.partida}
            bancoDePrecios={newModalPart.bancoDePrecios}
          />
        )}
      </ModalPartidaProvider>

      {bc3Link.open === true && <ModalImportPartFromBc3Link />}

      {partBrowser.open === true && <PartBrowserModal />}
    </div>
  )
}

export default WrapperModals
